module.exports = __webpack_public_path__ + "images/4bc7ed7ace9ac70fc964814fc5a7ae9c.png";